<template>
  <div>
    <Navbar></Navbar>
    <ListProducts></ListProducts>
  </div>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import ListProducts from "../components/ListProducts.vue";
export default {
  methods: {},
  components: {
    Navbar,
    ListProducts
  }
};
</script>

<style>
</style>